<div>
    <!-- Initial state: Empty state, waiting for the inbox list to be loaded -->
    <ng-container *ngIf="activeState === SMART_INBOX_STATE.INITIAL">
        <div class="initial-state">   
        </div>
    </ng-container>
    <!-- Connect state: When no accounts are found, show the welcome/connect component -->
    <ng-container *ngIf="activeState === SMART_INBOX_STATE.CONNECT">
        <app-inbox-welcome (onConnect)="onConnectSuccess()" (onError)="onConnectError($event)"></app-inbox-welcome>
    </ng-container>
    <!-- Connection error state: When the connection to the inbox fails, show the error on call component -->
    <ng-container *ngIf="activeState === SMART_INBOX_STATE.CONNECTION_ERROR">
        <app-inbox-error [errorType]="SMART_INBOX_STATE.CONNECTION_ERROR" (onAction)="onRetry()"></app-inbox-error>
    </ng-container>
    <!-- Service error state: When the service is down, show the error on call component -->
    <ng-container *ngIf="activeState === SMART_INBOX_STATE.SERVICE_ERROR">
        <app-inbox-error [errorType]="SMART_INBOX_STATE.SERVICE_ERROR"></app-inbox-error>
    </ng-container>
    <!-- Connected state: When the inbox is connected, show the inbox view component -->
    <ng-container *ngIf="activeState === SMART_INBOX_STATE.CONNECTED">
        <div class="inbox-viewer">
            <!-- <div class="sidebar">
                sidebar content
            </div> -->
            <app-inbox-view></app-inbox-view>
        </div>
    </ng-container>
</div>